<template>
  <tr>
    <td>{{ item.id }}</td>
    <td>{{ item.name }}</td>
    <td>{{ item.email }}</td>
    <td>
      <template v-if="item.social_network_accounts.length !== 0">
        {{ item.social_network_accounts[0].link }}
      </template>
    </td>
    <td>{{ item.pivot.income }}</td>
    <td class="icon-td">
      <v-icon small @click="remove()">fas fa-times</v-icon>
    </td>
  </tr>
</template>

<script>
import { updateUserRole } from '../../../../../api/user'

export default {
  name: 'ReferralItem',
  props: {
    item: {
      id: '',
      name: '',
      email: '',
      social_network_accounts: {
        link: ''
      },
      account: {
        value: ''
      }
    }
  },
  computed: {
    isDisabled: {
      get () {
        return this.item.roles.length === 0
      },
      set (newValue) {
        this.item.roles = newValue ? [] : ['user']
        updateUserRole(this.item.id, this.item.roles).then()
      }
    }
  },
  created () {
  },
  methods: {
    remove () {
      this.$root.$emit('remove_item', this.item.id)
    }
  }
}
</script>

<style scoped>
    .icon-td {
        text-align: center
    }

    .icon-td .icon {
        cursor: pointer;
        display: inline-block;
        width: 17px;
        height: 17px;
    }
</style>
